'use client';

import { jsx } from "react/jsx-runtime";
import { classNames } from "../../utils/styles/classNames.js";
import { option } from "./Select.css.js";
function FakeOption({ children }) {
  return /* @__PURE__ */ jsx("li", { "aria-selected": "false", className: classNames(option), role: "option", children });
}
export {
  FakeOption
};
